<template>
  <div>
    <div class="row" v-if="sendStatus === false">
      <div class="col-12">
        <div class="db-title db-title-question" style="margin-bottom: 40px;">
          So geht's jetzt <span class="db-title-green">weiter</span>:
        </div>
      </div>
      <div class="col-12">
        <div class="next-steps">
          <div class="row">
            <div class="col-12 col-sm-4 step">
              <div class="image-wrapper">
                <div class="image-circle">
                  <i class="fas fa-pen"></i>
                </div>
              </div>
              <p>
                Sie geben Ihre Kontaktdaten in das untenstehende Formular ein.
              </p>
            </div>
            <div class="col-12 col-sm-4 step">
              <div class="image-wrapper">
                <div class="image-circle">
                  <i class="fas fa-user-headset"></i>
                </div>
              </div>
              <p>
                Wir nehmen mit Ihnen kurzfristig Kontakt auf und erstellen für
                Sie ein finales Angebot inkl. Versandkosten.
              </p>
            </div>
            <div class="col-12 col-sm-4 step">
              <div class="image-wrapper">
                <div class="image-circle">
                  <i class="fas fa-truck"></i>
                </div>
              </div>
              <p>
                Sobald Sie das Angebot annehmen, werden die Produkte an Sie
                versandt.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="form-group">
          <label for="customerCompany">Firma</label>
          <input
            type="text"
            v-model="customerCompany"
            class="form-control"
            :class="{
              'is-invalid': errors != null && errors.customerCompany,
            }"
          />
          <small
            id="customerCompanyError"
            class="form-text text-danger"
            v-if="errors && errors.customerCompany"
            >{{ errors.customerCompany[0] }}</small
          >
        </div>
        <div class="form-group">
          <label for="customerFirstName">Vorname*</label>
          <input
            type="text"
            v-model="customerFirstName"
            class="form-control"
            :class="{
              'is-invalid': errors != null && errors.customerFirstName,
            }"
          />
          <small
            id="customerFirstNameError"
            class="form-text text-danger"
            v-if="errors && errors.customerFirstName"
            >{{ errors.customerFirstName[0] }}</small
          >
        </div>
        <div class="form-group">
          <label for="customerLastName">Nachname*</label>
          <input
            type="text"
            v-model="customerLastName"
            class="form-control"
            :class="{ 'is-invalid': errors != null && errors.customerLastName }"
          />
          <small
            id="customerLastNameError"
            class="form-text text-danger"
            v-if="errors && errors.customerLastName"
            >{{ errors.customerLastName[0] }}</small
          >
        </div>

        <div class="form-group">
          <label for="customerStreet">Straße / Hausnummer*</label>
          <input
            type="text"
            v-model="customerStreet"
            class="form-control"
            :class="{ 'is-invalid': errors != null && errors.customerStreet }"
          />
          <small
            id="customerStreetError"
            class="form-text text-danger"
            v-if="errors && errors.customerStreet"
            >{{ errors.customerStreet[0] }}</small
          >
        </div>

        <div class="row">
          <div class="col-6">
            <div class="form-group">
              <label for="customerZipcode">Postleitzahl*</label>
              <input
                type="text"
                v-model="customerZipcode"
                class="form-control"
                :class="{
                  'is-invalid': errors != null && errors.customerZipcode,
                }"
              />
              <small
                id="customerZipcodeError"
                class="form-text text-danger"
                v-if="errors && errors.customerZipcode"
                >{{ errors.customerZipcode[0] }}</small
              >
            </div>
          </div>
          <div class="col-6">
            <div class="form-group">
              <label for="customerCity">Ort*</label>
              <input
                type="text"
                v-model="customerCity"
                class="form-control"
                :class="{ 'is-invalid': errors != null && errors.customerCity }"
              />
              <small
                id="customerCityError"
                class="form-text text-danger"
                v-if="errors && errors.customerCity"
                >{{ errors.customerCity[0] }}</small
              >
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="form-group">
          <label for="customerEmail">E-Mail*</label>
          <input
            type="text"
            v-model="customerEmail"
            class="form-control"
            :class="{ 'is-invalid': errors != null && errors.customerEmail }"
          />
          <small
            id="customerEmailError"
            class="form-text text-danger"
            v-if="errors && errors.customerEmail"
            >{{ errors.customerEmail[0] }}</small
          >
        </div>
        <div class="form-group">
          <label for="customerPhone">Telefon</label>
          <input
            type="text"
            v-model="customerPhone"
            class="form-control"
            :class="{ 'is-invalid': errors != null && errors.customerPhone }"
          />
          <small
            id="customerPhoneError"
            class="form-text text-danger"
            v-if="errors && errors.customerPhone"
            >{{ errors.customerPhone[0] }}</small
          >
        </div>
        <div class="form-group">
          <label for="customerMobile"
            >Mobil*
            <small
              >(notwendig zur Abstimmung der Speditionslieferung und für etwaige
              Rückfragen)</small
            ></label
          >
          <input
            type="text"
            v-model="customerMobile"
            class="form-control"
            :class="{ 'is-invalid': errors != null && errors.customerMobile }"
          />
          <small
            id="customerMobileError"
            class="form-text text-danger"
            v-if="errors && errors.customerMobile"
            >{{ errors.customerMobile[0] }}</small
          >
        </div>
        <div class="form-group">
          <label for="customerShippinginfo"
            >Lieferhinweis
            <small
              >(Anmerkung zur Lieferung, z.B. Sackgasse, Altstadt)</small
            ></label
          >
          <input
            type="text"
            v-model="customerShippinginfo"
            class="form-control"
            :class="{
              'is-invalid': errors != null && errors.customerShippinginfo,
            }"
          />
          <small
            id="customerShippinginfoError"
            class="form-text text-danger"
            v-if="errors && errors.customerShippinginfo"
            >{{ errors.customerShippinginfo[0] }}</small
          >
        </div>
      </div>
      <div class="col-12">
        <div class="form-group">
          <label for="customerMessage"
            >Möchten Sie uns noch etwas mitteilen?</label
          >
          <textarea
            v-model="customerMessage"
            class="form-control"
            rows="8"
          ></textarea>
        </div>
        <div class="form-group">
          <input
            type="checkbox"
            name="agb"
            id="agb"
            value="agbConfirmed"
            v-model="agb"
            hidden
          />
          <label for="agb">
            <img
              class="db-checkbox"
              v-bind:src="
                agb === true
                  ? '/img/checkbox_true.jpg'
                  : '/img/checkbox_false.jpg'
              "
            />
            <small
              >Ich habe die
              <a
                href="https://www.deinebaustoffe.de/magesetup/frontend/agreements/id/4/"
                target="_blank"
                >Allgemeinen Geschäftsbedingungen und Widerrufsbelehrung</a
              >
              gelesen und stimme diesen ausdrücklich zu.*</small
            >
          </label>
          <small
            id="agbError"
            class="form-text text-danger"
            v-if="errors && errors.agb"
            >{{ errors.agb[0] }}</small
          >
        </div>
        <div class="form-group">
          <input
            type="checkbox"
            name="privacy"
            id="privacy"
            value="privacyConfirmed"
            v-model="privacy"
            hidden
          />
          <label for="privacy">
            <img
              class="db-checkbox"
              v-bind:src="
                privacy === true
                  ? '/img/checkbox_true.jpg'
                  : '/img/checkbox_false.jpg'
              "
            />
            <small
              >Ich habe die
              <a
                href="https://www.deinebaustoffe.de/magesetup/frontend/agreements/id/3/"
                target="_blank"
                >Datenschutzerklärung</a
              >
              gelesen und stimme dieser ausdrücklich zu.*</small
            >
          </label>
          <small
            id="privacyError"
            class="form-text text-danger"
            v-if="errors && errors.privacy"
            >{{ errors.privacy[0] }}</small
          >
        </div>
        <div v-if="errorsOther" class="text-warning">
          Es ist ein Fehler aufgetreten.
        </div>
      </div>
      <div class="col-12">
        <div class="col-12 sv_nav">
          <button @click="prevPage()" class="sv_prev_btn">Zurück</button>
          <button @click="sendRequest()" class="db-btn">
            Anfrage abschicken
          </button>
        </div>
      </div>
    </div>

    <div v-if="sendStatus === true">
      <div class="db-title">
        <span class="db-title-green">Sauber</span>, das war es schon!
      </div>
      <div class="db-textblock">
        Jetzt heißt es für Sie: zurücklehnen und entspannen – oder zurück auf
        die Baustelle. Wir kümmern uns um Ihre Anfrage sowie die benötigten
        Produkte und melden uns kurzfristig bei Ihnen. Eine Kopie Ihrer Anfrage
        ist bereits per E-Mail auf dem Weg zu Ihnen.
      </div>
      <div style="text-align: center;">
        <button @click="goToShop()" class="db-btn" style="float: none;">
          Stöbern auf deineBAUSTOFFE
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      customerFirstName: "",
      customerLastName: "",
      customerEmail: "",
      phone: "",
      customerStreet: "",
      customerZipcode: "",
      customerCity: "",
      customerMessage: "",
      customerPhone: "",
      customerMobile: "",
      customerCompany: "",
      customerShippinginfo: "",
      errors: null,
      errorsOther: false,
      agb: false,
      privacy: false,
    };
  },

  computed: {
    sendStatus() {
      return this.$parent.$store.state.submitted;
    },

    agbToString() {
      return this.agb === true ? "checked" : "";
    },

    privacyToString() {
      return this.privacy === true ? "checked" : "";
    },
  },

  mounted() {
    window.hj("vpv", "/kontaktformular");
    console.log("hj /kontaktformular");
  },

  methods: {
    sendRequest() {
      let self = this;

      let payload = {
        projectName: "Trockenbauwand",
        customerCompany: this.customerCompany,
        customerFirstName: this.customerFirstName,
        customerLastName: this.customerLastName,
        customerEmail: this.customerEmail,
        customerStreet: this.customerStreet,
        customerZipcode: this.customerZipcode,
        customerCity: this.customerCity,
        customerMessage: this.customerMessage,
        customerPhone: this.customerPhone,
        customerMobile: this.customerMobile,
        customerShippinginfo: this.customerShippinginfo,
        agb: this.agbToString,
        privacy: this.privacyToString,
        newsletter: this.newsletter,
        products: this.$store.state.products,
        surveyResult: JSON.stringify(this.$store.state.results),
      };

      let endpoint = "https://prometheus-api.db-ops.de/api/pipedrivedeal";

      if (
        location.hostname === "localhost" ||
        location.hostname === "127.0.0.1"
      ) {
        endpoint = "http://prometheus-base.test/api/pipedrivedeal";
      }

      axios
        .post(endpoint, payload)
        .then((res) => {
          if (res.data.status === "success") {
            console.log("OK");
            self.errors = null;
            self.$parent.$store.commit("setSubmit", true);

            window.hj("vpv", "/abschluss");
            console.log("hj /abschluss");
          } else if (
            res.data.status === "error" &&
            Object.keys(res.data.errors).length > 0
          ) {
            console.log("Validation error");
            console.log(res.data.errors);
            self.errors = res.data.errors;
          } else {
            console.log("Other errors");
            this.errorsOther = true;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    goToShop() {
      window.location.href = "https://www.deinebaustoffe.de";
    },

    prevPage() {
      this.$store.commit("setActivePage", "productList");
    },
  },
};
</script>

<style scoped></style>
